import { render, staticRenderFns } from "./ModalCompletedTask.vue?vue&type=template&id=423a4f4b&"
import script from "./ModalCompletedTask.vue?vue&type=script&lang=js&"
export * from "./ModalCompletedTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports